// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2N51M","messages":"Chat_messages__1Bi6W","dateDivider":"Chat_dateDivider__2_MXG"};